<template>
	<v-text-field
		ref="placeSearch"
		outlined
		hide-details
		placeholder="การเดินทางไปทำงาน/เรียน จากตรงนี้ใช้เวลากี่นาที"
		class="mb-2 placeSearch"
	/>
</template>

<script>
export default {
	props: {
		propertyLocation: {
			type: Object,
			default: () => ({})
		},
		placeSelected: {
			type: Function,
			default: () => {}
		}
	},

	mounted () {

		this.$googleMapsLoader.load(google => {
			// Place search autocomplete
			var autocomplete = new google.maps.places.Autocomplete(this.$refs.placeSearch.$refs.input, {
				origin: this.propertyLocation,
				componentRestrictions: { country: 'th' }
			})
			autocomplete.addListener('place_changed', () => {
				let place = autocomplete.getPlace()
				this.$refs.placeSearch.$refs.input.value = ''

				if (this.placeSelected) {
					this.placeSelected(place)
				}
			})
		})

	}
}
</script>

<style lang="scss" scoped>
::v-deep .v-input__control {
	background-color: #fff;
	border-radius: 0;
}
</style>
